import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { useServiceAccess } from '../../context/ServiceAccessContext';
import { useAuth } from '../../context/AuthContext';

interface ServiceRouteProps {
  serviceSlug: string;
  children: React.ReactNode;
  redirectTo?: string;
}

const ServiceRoute: React.FC<ServiceRouteProps> = ({
  serviceSlug,
  children,
  redirectTo = '/home',
}) => {
  const { canAccess, ready } = useServiceAccess();
  const { isIndividual } = useAuth();
  const { t } = useTranslation('common');

  if (!ready) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          color: '#94a3b8',
        }}
      >
        {t('labels.loading')}
      </div>
    );
  }

  if (!canAccess(serviceSlug)) {
    if (isIndividual) {
      return <Navigate to="/plans" replace state={{ locked: serviceSlug }} />;
    }
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ServiceRoute;